module.exports = __webpack_public_path__ + "static/media/UP_ok.cb4f3539.svg";